// extracted by mini-css-extract-plugin
export var lg = "_4n-4";
export var md = "_4n-3";
export var sm = "_4n-2";
export var xs = "_4n-1";
export var xxs = "_4n-0";